// extracted by mini-css-extract-plugin
module.exports = {"confirmModal":"UmwxK","checkbox":"hpYaN","content":"o7aEF","dot":"x0dv-"};